import * as AT from '../actions/_types'
import { initSettingTypeKeys } from '../constants'

const updateSetting = (prevState = {}, action) => {
  switch (action.type) {
    case AT.MESSAGE_SETTINGS_UPDATE: {
      return Object.assign({}, prevState, action.nextSetting)
    }
    case AT.MESSAGE_SETTINGS_DEACTIVATE: {
      return {
        ...prevState,
        active: false,
      }
    }
    case AT.MESSAGE_SETTINGS_ACTIVATE: {
      return {
        ...prevState,
        active: true,
      }
    }
    default: {
      return prevState
    }
  }
}

const updateIdListByType = (prevState = [], action) => {
  switch (action.type) {
    case AT.MESSAGE_SETTINGS_DEACTIVATE: {
      const ind = prevState.indexOf(action.settingId)
      const head = prevState.slice(0, ind)
      const tail = prevState.slice(ind + 1)

      return head.concat(tail)
    }
    case AT.MESSAGE_SETTINGS_ACTIVATE: {
      return prevState.concat(action.settingId)
    }
    default: {
      return prevState
    }
  }
}

// in case user wants to 'undo' a deactivation, store an id
const handleUndos = (prevState = null, action) => {
  switch (action.type) {
    case AT.MESSAGE_SETTINGS_DEACTIVATE: {
      return action.settingId
    }
    case AT.MESSAGE_SETTINGS_UNDO_DEACTIVATE: {
      return null
    }
    default: {
      return prevState
    }
  }
}

export default (
  prevState = {
    isLoaded: false,
    byId: {},
    idsByType: initSettingTypeKeys(), // { reminder: [], no_show: [], ... }
    lastRemovedId: null,
    newApptSettings: {},
    missedCallSettings: {},
    reviewsOffset: null,
    reviewSettings: {},
    schedulingSettings: {},
    socialLinks: null,
  },
  action,
) => {
  switch (action.type) {
    case AT.MESSAGE_SETTINGS_UPDATE: {
      const { settingId } = action
      const updatedSetting = updateSetting(prevState.byId[settingId], action)
      const nextState = Object.assign({}, prevState.byId, {
        [settingId]: updatedSetting,
      })
      return {
        ...prevState,
        byId: nextState,
      }
    }
    case AT.MESSAGE_SETTINGS_CREATE: {
      const { settingId, nextSetting, messageSettingType } = action

      const nextById = {
        ...prevState.byId,
        [settingId]: nextSetting,
      }

      const nextIdsByType = {
        ...prevState.idsByType,
        [messageSettingType]:
          prevState.idsByType[messageSettingType].concat(settingId),
      }

      return {
        ...prevState,
        byId: nextById,
        idsByType: nextIdsByType,
      }
    }
    case AT.MESSAGE_SETTINGS_ACTIVATE:
    case AT.MESSAGE_SETTINGS_DEACTIVATE: {
      const { messageSettingType, settingId } = action

      const nextById = {
        ...prevState.byId,
        [settingId]: updateSetting(prevState.byId[settingId], action),
      }
      const nextIdsByType = {
        ...prevState.idsByType,
        [messageSettingType]: updateIdListByType(
          prevState.idsByType[messageSettingType],
          action,
        ),
      }
      const lastRemovedId = handleUndos(prevState.lastRemovedId, action)

      return {
        ...prevState,
        byId: nextById,
        idsByType: nextIdsByType,
        lastRemovedId,
      }
    }
    case AT.MESSAGE_SETTINGS_UNDO_DEACTIVATE: {
      // TODO: add back to its list of idsByType
      const lastRemovedId = handleUndos(
        AT.MESSAGE_SETTINGS_UNDO_DEACTIVATE,
        action,
      )

      return {
        ...prevState,
        lastRemovedId,
      }
    }
    case AT.MESSAGE_SETTINGS_RECEIVE: {
      const {
        byId,
        idsByType,
        customMessageSettings,
        reviewSettings,
        schedulingSettings,
        newApptSettings,
        missedCallSettings,
      } = action
      return {
        ...prevState,
        isLoaded: true,
        byId,
        idsByType,
        customMessageSettings,
        reviewSettings,
        schedulingSettings,
        newApptSettings,
        missedCallSettings,
      }
    }
    case AT.MESSAGE_SETTINGS_SET_REVIEWS_OFFSET: {
      const { reviewsOffset } = action
      return {
        ...prevState,
        reviewsOffset,
      }
    }
    case AT.MESSAGE_SETTINGS_SET_SOCIAL_LINKS: {
      const { links } = action
      return {
        ...prevState,
        socialLinks: links,
      }
    }
    default: {
      return prevState
    }
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers/message-settings.js